import { QueryClientProvider } from '@tanstack/react-query';
import { EnvironmentIndicator } from '@pptcreate/ui';
import type { ReactNode } from 'react';

import { getAppEnv } from '@/lib/app-env';
import { queryClient } from '@/lib/query-client';
import { AuthProvider } from '@/providers/AuthProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {children}
        <EnvironmentIndicator environment={getAppEnv()} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
